import { Edit05, LinkBroken01, LinkExternal02 } from '@untitled-ui/icons-react';

import { IconButton } from '../../../../components/buttons/icon-button';

export type LinkHoverTooltipProps = {
  href: string;
  text: string;
  onEdit: () => void;
  onUnlink: () => void;
};

function truncateUrl(url: string, maxLength: number = 36): string {
  if (url.length <= maxLength) {
    return url;
  }
  return url.slice(0, maxLength) + '...';
}

export function LinkHoverTooltip(props: LinkHoverTooltipProps) {
  const { href, onEdit, onUnlink } = props;

  function handleOpenInNewTab() {
    window.open(href, '_blank', 'noopener,noreferrer');
  }

  return (
    <div className="flex w-fit items-center gap-2 rounded-md border border-branding-gray bg-white px-3 py-1 shadow-2">
      <span className="font-body-1-m max-w-[300px] truncate text-sm text-dark-gray">
        {truncateUrl(href)}
      </span>
      <div className="flex items-center gap-1">
        <IconButton
          icon={<LinkExternal02 width={16} height={16} className="[&>path]:stroke-[2]" />}
          variant="ghost-neutral"
          onClick={handleOpenInNewTab}
          aria-label="Open link in new tab"
          className="text-black"
        />
        <IconButton
          icon={<LinkBroken01 width={16} height={16} className="[&>path]:stroke-[2]" />}
          variant="ghost-neutral"
          onClick={onUnlink}
          aria-label="Remove link"
          className="text-black"
        />
        <IconButton
          icon={<Edit05 width={16} height={16} className="[&>path]:stroke-[2]" />}
          variant="ghost-neutral"
          onClick={onEdit}
          aria-label="Edit link"
          className="text-black"
        />
      </div>
    </div>
  );
}
